import { Component, computed, effect, inject, model, signal } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AppstateService } from 'src/app/services/appstate.service';
import { DataService } from 'src/app/services/data.service';
import { IKlassifizierung } from 'src/app/types/IKlassifizierung';
import { IProjektantrag } from 'src/app/types/IProjektantrag';
import { IQuartier } from 'src/app/types/IQuartier';
import { IUser } from 'src/app/types/IUser';
import { ProjektantragViewModel } from 'src/app/types/viewmodels/projektantrag.viewmodel';

@Component({
  selector: 'app-projekt-antrag',
  // standalone: true,
  // imports: [],
  templateUrl: './projekt-antrag.component.html',
  styleUrl: './projekt-antrag.component.css'
})
export class ProjektAntragComponent {

  readonly dialogRef = inject(MatDialogRef<ProjektAntragComponent>);

  public dataProjektantrag = computed<ProjektantragViewModel>(() => this.dataService.projektAntrag());
  public dataAntragNeu = signal<IProjektantrag>({} as IProjektantrag);
  public dataVerwaltungsbereichId = signal<number | undefined>(undefined);
  public isBauControlling = computed<boolean>(() => this.dataVerwaltungsbereichId() ? this.dataVerwaltungsbereichId() == 1 : false);

  constructor(public appStateService: AppstateService, 
              private dataService: DataService,) {
    effect(() => {
      this.dataAntragNeu.set({ ...this.dataProjektantrag().projektantrag });
    }, { allowSignalWrites: true });

    effect(() => {
      if (this.isBauControlling()) {
        this.dataAntragNeu().kostenstelle = "";
        this.dataAntragNeu().kostengruppeId = undefined; 
      }
    });

  }

  onSaveButtonClick(): void {
    this.dialogRef.close(this.dataAntragNeu());
  }

  onCloseButtonClick(): void {
    this.dialogRef.close();
  }

  public controllingbereichChange(e: any) {
    var verwaltungsbereich = this.dataProjektantrag().controllingbereiche?.find((x) => x.controllingbereichID == e)?.verwaltungsbereich ?? undefined;
    this.dataVerwaltungsbereichId.set(verwaltungsbereich);
    // reset all dependent fields
    this.dataAntragNeu().klassifizierungId = undefined;
    this.dataAntragNeu().projektmanagerId = undefined;
    this.dataAntragNeu().projektsteuererId = undefined;
  }

  public plangebietChange(e: any) {
    // reset all dependent fields
    this.dataAntragNeu().quartierId = undefined;
    this.dataAntragNeu().projektmanagerId = undefined;
    this.dataAntragNeu().projektsteuererId = undefined;
  }

  getKlassifizierungen(): IKlassifizierung[] {
    return this.dataProjektantrag().klassifizierungen?.filter((x) => x.controllingbereich == this.dataAntragNeu().controllingbereichId)
  }

  getQuartiere(): IQuartier[] {
    return this.dataProjektantrag().quartiere?.filter((x) => x.plangebiet == this.dataAntragNeu().plangebietId || x.plangebiet== null) ?? [];
  }

  getProjektManager(): IUser[] {
    var verwaltungsbereich = this.dataProjektantrag().controllingbereiche?.find((x) => x.controllingbereichID == this.dataAntragNeu().controllingbereichId)?.verwaltungsbereich ?? 0;
    return this.dataProjektantrag().projektmanager?.filter(
      (x) => x.userPlangebietBereiche.filter(
        (y) => y.plangebiet == this.dataAntragNeu().plangebietId && y.verwaltungsbereich == verwaltungsbereich).length > 0
    ) ?? [];
  }

  getProjektSteuerer(): IUser[] {
    return this.dataProjektantrag().projektsteuerer?.filter(
      (x) => x.userPlangebietBereiche.filter(
        (y) => y.plangebiet == this.dataAntragNeu().plangebietId).length > 0
    ) ?? [];
  }

  getKostengruppen(): any[] {
    var verwaltungsbereich = this.dataProjektantrag().controllingbereiche?.find((x) => x.controllingbereichID == this.dataAntragNeu().controllingbereichId)?.verwaltungsbereich ?? 0;
    return this.dataProjektantrag().kostengruppen
      ?.filter((x) => x.verwaltungsbereichID == verwaltungsbereich)
      .sort((a, b) => (a.sort ?? 0) - (b.sort ?? 0)) ?? [];
  }

}
